import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import Form from '@atlaskit/form';
import { Box, Stack } from '@atlaskit/primitives';
import { cssMap } from '@atlaskit/css';

import { ToneSelector } from './ToneSelector';
import { DurationSelector } from './DurationSelector';

const styles = cssMap({
	grow: {
		flex: 1,
	},
});

const i18n = defineMessages({
	applyButtonLabel: {
		id: 'audio.audio-briefing-popup.customize-tab.apply',
		defaultMessage: 'Apply customizations',
		description: 'Label for the button used to apply briefing customizations',
	},
});

export const AudioBriefingPopupCustomizePanel = () => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.grow}>
			<Form onSubmit={() => {}}>
				{({ formProps }) => (
					<form {...formProps}>
						<Stack space="space.100">
							<ToneSelector />
							<DurationSelector />
							<Box paddingBlockStart="space.150">
								<Button type="submit" appearance="primary" shouldFitContainer>
									{formatMessage(i18n.applyButtonLabel)}
								</Button>
							</Box>
						</Stack>
					</form>
				)}
			</Form>
		</Box>
	);
};
